// src/pages/services/CloudDevOps.jsx

import { ChevronLeft, ChevronRight } from "lucide-react";
import { useRef } from "react";
import ServiceFeatureCard from "../../components/ServiceFeatureCard";
import img1 from "../../assets/cloud1.jpg";
import img2 from "../../assets/cloud2.jpg";
import img3 from "../../assets/cloud3.jpg";
import img4 from "../../assets/cloud4.jpg";
import img5 from "../../assets/cloud5.jpg";
import img6 from "../../assets/cloud6.jpg";
import bannerImg from "../../assets/ser3.jpg";
import overviewImg from "../../assets/cloud.jpg";
import ServiceLayout from "../../components/ServiceLayout";

export default function CloudDevOps() {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const amount = 320;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -amount : amount,
        behavior: "smooth",
      });
    }
  };

  const capabilities = [
    {
      title: "Multi-Cloud Strategy",
      description: "Design cloud-agnostic solutions across AWS, Azure, and GCP.",
    },
    {
      title: "Infrastructure as Code (IaC)",
      description: "Automate infrastructure using tools like Terraform, CloudFormation, and Pulumi.",
    },
    {
      title: "CI/CD Automation",
      description: "Accelerate deployments with Jenkins, GitHub Actions, and GitLab CI.",
    },
    {
      title: "Security & Compliance",
      description: "Enforce best practices with identity management, encryption, and governance.",
    },
  ];

  const services = [
    {
      title: "DevOps Consulting & Implementation",
      image: img1,
      description: "Strategize and implement DevOps best practices to optimize your development and operations workflows.",
    },
    {
      title: "Cloud Migration Services",
      image: img2,
      description: "Seamlessly migrate your existing infrastructure, applications, and data to AWS, Azure, or GCP.",
    },
    {
      title: "Cloud Security & Compliance",
      image: img3,
      description: "Secure your cloud infrastructure with identity management, encryption, and compliance strategies.",
    },
    {
      title: "Continuous Integration & Continuous Deployment (CI/CD)",
      image: img4,
      description: "Implement efficient CI/CD pipelines for faster, reliable, and automated software delivery.",
    },
    {
      title: "Cloud Infrastructure Management",
      image: img5,
      description: "Maintain and optimize your cloud infrastructure for performance, scalability, and cost-efficiency.",
    },
    {
      title: "Managed DevOps Services",
      image: img6,
      description: "Let our experts manage your DevOps pipelines and cloud environments, ensuring smooth operations.",
    },
  ];

  return (
    <ServiceLayout
      title="Cloud & DevOps Solutions"
      bannerImg={bannerImg}
      overviewImg={overviewImg}
      overviewHeading="Achieve agility, scalability, and reliability through modern cloud and DevOps practices."
      overviewText="We help organizations adopt cloud-native architectures, automate infrastructure, and streamline deployments for faster time to market and reduced costs."
      capabilities={capabilities}
      buttonText="Get a Custom Cloud Solution"
      servicesHeading="Our Cloud & DevOps Services"
    >
      <div className="relative px-4 sm:px-6 pb-16">
        <div className="relative flex items-center">
          <button
            onClick={() => scroll("left")}
            className="hidden sm:block absolute left-4 z-10 bg-white border rounded-full p-2 shadow-md hover:bg-gray-100"
            style={{ top: "35%", transform: "translateY(-50%)" }}
          >
            <ChevronLeft size={40} />
          </button>

          <div
            ref={scrollRef}
            className="flex gap-4 overflow-x-auto scroll-smooth px-4 sm:px-12 scrollbar-hide w-full"
            style={{ scrollBehavior: "smooth" }}
          >
            {services.map((service, idx) => (
              <div
                key={idx}
                className="min-w-[300px] max-w-[300px] h-[250px] flex-shrink-0 transform transition-transform duration-300 hover:scale-105"
              >
                <ServiceFeatureCard
                  title={service.title}
                  image={service.image}
                  description={service.description}
                  link="/contact"
                />
              </div>
            ))}
          </div>

          <button
            onClick={() => scroll("right")}
            className="hidden sm:block absolute right-4 z-10 bg-white border rounded-full p-2 shadow-md hover:bg-gray-100"
            style={{ top: "35%", transform: "translateY(-50%)" }}
          >
            <ChevronRight size={40} />
          </button>
        </div>
      </div>
    </ServiceLayout>
  );
}
